function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_icons_main_1564511",
  transform: "translate(-2 -2)"
}, React.createElement("g", {
  id: "main",
  transform: "translate(2 2)"
}, React.createElement("path", {
  id: "Path_106",
  "data-name": "Path 106",
  d: "M18.5,12h-3A1.5,1.5,0,0,0,14,13.5V18a1.5,1.5,0,0,0,1.5,1.5h3A1.5,1.5,0,0,0,20,18V13.5A1.5,1.5,0,0,0,18.5,12Z",
  transform: "translate(-5 -4.5)"
}), React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  d: "M6.5,2h-3A1.5,1.5,0,0,0,2,3.5V8A1.5,1.5,0,0,0,3.5,9.5h3A1.5,1.5,0,0,0,8,8V3.5A1.5,1.5,0,0,0,6.5,2Z",
  transform: "translate(-2 -2)"
}), React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M18.5,2h-3A1.5,1.5,0,0,0,14,3.5V5a1.5,1.5,0,0,0,1.5,1.5h3A1.5,1.5,0,0,0,20,5V3.5A1.5,1.5,0,0,0,18.5,2Z",
  transform: "translate(-5 -2)"
}), React.createElement("path", {
  id: "Path_109",
  "data-name": "Path 109",
  d: "M6.5,16h-3A1.5,1.5,0,0,0,2,17.5V19a1.5,1.5,0,0,0,1.5,1.5h3A1.5,1.5,0,0,0,8,19V17.5A1.5,1.5,0,0,0,6.5,16Z",
  transform: "translate(-2 -5.5)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/dashboard.477ce947.svg";
export { SvgComponent as ReactComponent };